import React from 'react';
import { Image, StyleSheet, Text, TextInput, View } from './base_components';
import InlineTextButton from './buttons/inline_text_button';
import TextButton from './buttons/text_button';

const styles = StyleSheet.create({
  signupDialog: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogSpacer: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    marginTop: '2rem',
    width: '12rem',
    height: '2.4rem',
  },
  boxView: {
    alignSelf: 'stretch',
    margin: '2rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  box: {
    flex: 1,
    maxWidth: '40rem',
    padding: '2rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--signup-dialog-bg)',
    borderColor: 'var(--signup-dialog-border)',
    borderWidth: 1,
    borderRadius: '1.5rem',
  },
  topIconView: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleView: {
    marginBottom: '2rem',
    width: '5.6rem',
    height: '5.6rem',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5.6rem',
    boxShadow: '0px 2px 4px 0px #0023FF40 inset, 0px 1px 11.3px 18px #0023FF0A',
    overflow: 'visible',
  },
  icon: {
    width: '3.2rem',
    height: '3.2rem',
    filter: 'var(--signup-icon-color)',
  },
  title: {
    color: 'var(--signup-title-text)',
    fontSize: '2.4rem',
    fontWeight: '500',
    textAlign: 'center',
  },
  subtitle: {
    marginTop: '1.5rem',
    color: 'var(--signup-subtitle-text)',
    fontSize: '1.8rem',
    fontWeight: '500',
    textAlign: 'center',
  },
  input: {
    marginTop: '3rem',
    alignSelf: 'stretch',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    height: '5.4rem',
    color: 'var(--signup-input-text)',
    fontSize: '1.6rem',
    fontWeight: '500',
    borderRadius: '1rem',
    borderWidth: 1,
    borderColor: 'var(--signup-input-border)',
    backgroundColor: 'var(--signup-input-bg)',
    '::placeholder': {
      color: 'var(--signup-input-placeholder)',
    },
  },
  button: {
    marginTop: '1.5rem',
    alignSelf: 'stretch',
    height: '5.4rem',
  },
  buttonText: {
    fontSize: '1.6rem',
  },
  bottomLine: {
    marginTop: '2.5rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomText: {
    color: 'var(--login-resend-text)',
    fontSize: '1.5rem',
    fontWeight: '500',
  },
  bottomLink: {
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
    color: 'var(--link-text-color)',
    fontSize: '1.5rem',
    fontWeight: '500',
    textDecoration: 'underline',
  },
});
const LOGO = require('../assets/img/logo.png');
type Props = {
  style?: any;
  icon: any;
  title: string;
  subtitle?: string;
  value?: string;
  onChangeText?: (new_value: string) => void;
  placeholder?: string;
  buttonText?: string;
  onPress?: () => void;
  children?: any;
  bottomText?: string;
  bottomLinkText?: string;
  onBottomPress?: () => void;
};
export default function SignupDialog(props: Props) {
  return (
    <View style={[styles.signupDialog, props.style]}>
      <View style={styles.dialogSpacer}>
        <Image style={styles.logo} source={LOGO} />
      </View>
      <View style={styles.boxView}>
        <View style={styles.box}>
          <View style={styles.topIconView}>
            <View style={styles.circleView}>
              <Image style={styles.icon} source={props.icon} />
            </View>
          </View>
          <Text style={styles.title}>{props.title}</Text>
          {props.subtitle ? (
            <Text style={styles.subtitle}>{props.subtitle}</Text>
          ) : null}
          {props.onChangeText ? (
            <TextInput
              style={styles.input}
              placeholder={props.placeholder}
              value={props.value}
              onChangeText={props.onChangeText}
              autoFocus={true}
              autoCapitalize='off'
              autoCorrect='off'
              inputMode='text'
              type='text'
              onSubmitEditing={props.onPress}
            />
          ) : null}
          {props.onPress && props.buttonText ? (
            <TextButton
              style={styles.button}
              textStyle={styles.buttonText}
              type='blue'
              text={props.buttonText}
              onPress={props.onPress}
            />
          ) : null}
          {props.children}
          {props.bottomText || props.bottomLinkText ? (
            <View style={styles.bottomLine}>
              {props.bottomText ? (
                <Text style={styles.bottomText}>{props.bottomText}</Text>
              ) : null}
              {props.bottomLinkText ? (
                <InlineTextButton
                  style={styles.bottomLink}
                  text={props.bottomLinkText}
                  onPress={props.onBottomPress}
                />
              ) : null}
            </View>
          ) : null}
        </View>
      </View>
      <View style={styles.dialogSpacer} />
    </View>
  );
}
